import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  batchId: string;
  softDelete?: boolean;
}

export const useDeleteBatch = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ batchId, softDelete }: HookProps) => {
      await request({
        path: `batches/${batchId}`,
        method: 'DELETE',
        authenticate: true,
        dataObject: {
          softDelete,
        },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['batches'] });
      toast.success('Successfully deleted the batch!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error deleting the batch!');
    },
  });
};
